import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { restaurantSlug, productSlug } = useLocalSearchParams<{
    restaurantSlug: string;
    productSlug: string;
  }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Customization — {restaurantSlug}/{productSlug}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton href="/" label="Close" dismiss />
    </ExpoRouterDemoScreen>
  );
}
